import React from 'react';
import ReactTable from 'react-table'
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import { renderToStaticMarkup } from 'react-dom/server';





class BonusPage extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	show:false,
	    }
	    this.renderEditable = this.renderEditable.bind(this)
	}
	
	handleProportionCellBlur = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		isNaN(value) ? value = 0 : ''
		this.props.updateRowsInfo(cellInfo, value)
	}
	handleProportionCellChange = (cellInfo, event) => {
		const data = this.props.rows
		let value =  parseInt(event.target.value)
		this.props.updateRowsInfo(cellInfo, value)
	}
	
	renderEditable(cellInfo) {
	    return (
	      <div>
	        <input 
	        	type="number"
	        	value={this.props.rows[cellInfo.index][cellInfo.column.id]}
				onBlur={(e) =>{this.handleProportionCellBlur(cellInfo, e)}}
				onChange={(e) =>{this.handleProportionCellChange(cellInfo, e)}}
				className="editable-cell"
	      	/>
	      </div>	
	    );
	 }

	cancelDeleteBonusValues = () => {
	    this.setState({ show: false })
	}

	confirmDelete = () => {
	    this.setState({ show: true})
	}

	deleteBonus = () => {
		this.setState({show: false}, this.props.deleteMethod())
	}

	render() {
		let data  = this.props.rows
		return (
			<div>
				 <SweetAlert
		          	show={this.state.show}
		          	title="Confirmar"
		          	text={renderToStaticMarkup(<h5>¿Eliminar los valores de Bonos?</h5>)}
		          	html
		          	onConfirm={() => this.deleteBonus()}
		          	onCancel = {() => this.cancelDeleteBonus()}
		          	confirmButtonText= 'Eliminar'
		          	cancelButtonText= 'Cancelar'
		          	showCancelButton
		        />
				<div className="flex">
					<h3>Valores por hora bonos BRP </h3>
				</div>
				<div className='proportions-container'>
			        <ReactTable
			          data={this.props.rows}
			          resizeable={true}
			          columns={[
			            {
			              Header: "Cantidad de horas",
			              accessor: "label",
			              maxWidth: 200,
			              className: 'proportion-cell'
			            },
			            {
			              Header: "BRP Titulo",
			              accessor: "titulo",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			   			{
			              Header: "BRP Mencion",
			              accessor: "mencion",
			              maxWidth: 200,
			              className: 'proportion-cell',
			              Cell: this.renderEditable
			            },
			          ]}
			          defaultPageSize={10}
			          className="-striped -highlight"
			        />
		      	</div>
		    </div>
      	)
	}

}

export default BonusPage


// WEBPACK FOOTER //
// ./src/components/bonus/BonusPage.js